export default import.meta.ROLLDOWN_FILE_URL_RCaHVq_jCUoWDQWiWLxE3w + "?dataUrl"